
import {Component, OnInit, OnDestroy} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Filters, Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {CustomInputEditor} from '../custom-inputEditor';

@Component({
  selector: 'app-faq-document-upload',
  templateUrl: './faq-document-upload.component.html',
  styleUrls: ['./faq-document-upload.component.css']
})
export class FaqDocumentUploadComponent implements OnInit, OnDestroy {
  show: boolean;
  dataset: any[];
  totalData: number;
  respObject: any;
  displayData: any;
  add = false;
  del = false;
  edit = false;
  view = false;
  isError = false;
  errorMessage: string;
  private notifier: NotifierService;
  private clientId: number;
  type: string;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private userAuth: Subscription;
  offset: number;
  fileUploadUrl: string;
  uploadButtonName = 'Upload File';
  attachment: any;
  uploadSuccessMessage: string;
  formData: any;
  dataLoaded: boolean;
  showIndex: boolean;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
    private modalService: NgbModal, notifier: NotifierService) {
      this.notifier = notifier;
      this.messageService.getCellChangeData().subscribe(item => {
          switch (item.type) {
              case 'change':
                  console.log('changed');
                  if (!this.messageService.edit) {
                      this.notifier.notify('error', 'You do not have edit permission');
                  } else {
                  }
                  break;
              case 'delete':
                  // console.log('deleted');
                  if (!this.messageService.del) {
                      this.notifier.notify('error', 'You do not have delete permission');
                  } else {
                      if (confirm('Are you sure?')) {
                          this._rest.deleteFaqDocumentLog({
                              id: item.id,
                              user_id: this.messageService.getUserId()
                          }).subscribe((res) => {
                              this.respObject = res;
                              if (this.respObject.success) {
                                  // this.totalData = this.totalData - 1;
                                  // this.messageService.setTotalData(this.totalData);
                                  this.messageService.sendAfterDelete(item.id);
                              } else {
                                  this.notifier.notify('error', this.respObject.errorMessage);
                              }
                          }, (err) => {
                              this.notifier.notify('error', this.respObject.errorMessage);
                          });
                      }
                  }
                  break;
          }
      });
     }

  ngOnInit() {
    this.dataLoaded = false;
    this.showIndex = true;
    this.fileUploadUrl = this._rest.apiRoot + '/uploadFaq';
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain FAQ Document Upload',
      openModalButton: 'FAQ Document Upload',
      breadcrumb: 'FAQ',
      folderName: 'FAQ Document Upload',
      tabName: 'FAQ',
        indexButton: 'Index'
  };
  const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      {
          id: 'original_document_nm', name: 'Original Document Name ', field: 'original_document_nm', sortable: true, filterable: true
      },
      {
          id: 'document_nm', name: 'Document Name ', field: 'document_nm', sortable: true, filterable: true
      },
      {
          id: 'document_path', name: 'Name', field: 'document_path', sortable: true, filterable: true
      }
  ];
  this.messageService.setColumnDefinitions(columnDefinitions);
  if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
  } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
          this.view = auth[0].viewFlag;
          this.add = auth[0].addFlag;
          this.edit = auth[0].editFlag;
          this.del = auth[0].deleteFlag;
          this.clientId = auth[0].clientId;
          this.baseFlag = auth[0].baseFlag;
          this.onPageLoad();
      });
  }
}


onPageLoad() {
    this.formData = {
        'clientId': this.clientId,
        'createdBy': this.messageService.getUserId(),
        'type': 'type',
        'user_id': this.messageService.getUserId()
    };
  this.getTableData();
}

createIndex() {
    this._rest.faqDocumentIndex().subscribe((res1) => {
        this.respObject = res1;
        // this.dataLoaded = true;
        if (this.respObject.success) {
            // this.dataLoaded = false;
            this.notifier.notify('success', 'Faq index successfully');
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', JSON.stringify(err));
    });
}

changeRouting(path: string) {
  this.messageService.changeRouting(path);
}

openModal(content) {
  if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
  } else {
      this.isError = false;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {
      });
  }
}

onFileError(msg: string) {
    this.isError = true;
    this.errorMessage = msg;
}

onFileComplete(data: any) {
    if (data.success) {
        const insertData = {
            clientId: this.clientId,
            originalDocumentName: data.fileName,
            documentName: data.changedName,
            documentPath: data.uploadPath + '/' + data.changedName,
            createdBy: this.messageService.getUserId()
        };
        this._rest.insertFaqDocumentLog(insertData).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                const id = this.respObject.details;
                this.messageService.setRow({
                    id: id,
                    original_document_nm: data.fileName,
                    document_nm: data.changedName,
                    document_path: data.uploadPath + '/' + data.changedName
                });
                this.totalData = this.totalData + 1;
                this.messageService.setTotalData(this.totalData);

                if (this.totalData <= this.pageSize * this.page_no) {
                    this.offset = id;
                    this.nextOffset = 0;
                } else {
                    this.nextOffset = this.offset;
                }
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }
}


getTableData() {
  if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
  } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }
}

isEmpty(obj) {
  for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
          return false;
      }
  }
  return true;
}

getData(paginationObj) {
  const offset = paginationObj.offset;
  const paginationType = paginationObj.paginationType;
  this.dataLoaded = false;
  this._rest.getFaqDocumentLog(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
  }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
  });
}

executeResponse(respObject, offset, paginationType) {
  if (respObject.success) {
      this.dataLoaded = true;
      if (offset === 0) {
          this.totalData = respObject.details.totalData[0].count;
          this.totalPage = respObject.details.totalPage;
          if (this.totalPage === 0) {
              this.totalPage = 1;
          }
      }
      if (!this.isEmpty(respObject.details.dataObj)) {
          const data = respObject.details.dataObj;
          this.nextOffset = respObject.details.nextOffset;
          this.offset = respObject.details.nextOffset;
          this.previousOffset = respObject.details.previousOffset;
          this.messageService.setTotalData(this.totalData);
          this.messageService.setGridData(data);
          // ----------------------------------------------
          if (offset !== 0) {
              const totalCount = this.totalData;
              const divRes = totalCount / this.pageSize;
              const remainder = totalCount % this.pageSize;
              if (remainder === 0) {
                  this.totalPage = parseInt(String(divRes), 10);
              } else {
                  this.totalPage = parseInt(String(divRes), 10) + 1;
              }
          }
          // ------------------------------------------------
          if (paginationType === 'next') {
              this.page_no = this.page_no + 1;
          } else if (paginationType === 'prev') {
              this.page_no = this.page_no - 1;
          } else if (paginationType === '' && this.page_no === 0) {
              this.page_no = this.page_no + 1;
          }
          if (this.totalData <= this.pageSize * this.page_no) {
              this.nextOffset = 0;
          }
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
          this.nextOffset = 0;
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
          this.previousOffset = 0;
      } else if (paginationType === '' && this.page_no === 0) {
          this.page_no = this.page_no + 1;
      }
  } else {
      this.notifier.notify('error', respObject.errorMessage);
  }
}

onPageSizeChange(value: any) {
  this.page_no = 0;
  this.nextOffset = 0;
  this.pageSize = value;
  this.getData({'offset': this.nextOffset, 'paginationType': ''});
}

ngOnDestroy(): void {
  if (this.userAuth) {
      this.userAuth.unsubscribe();
  }
}


}
